// HELPERS
import tableFilter from '../../../../helpers/tableFilter';

// UTILS
import naUTL from '../../../../../../utils/naUTL';

const jsonTableRow = (dataSources) => {
  const { nationalID, socialSecurity, watchlistAML } = dataSources;

  const table = [
    {
      col1: 'Status',
      col2: naUTL(nationalID.status),
      col3: naUTL(socialSecurity.status),
      col4: naUTL(watchlistAML.status),
    },
    {
      col1: 'Safe Harbour Score',
      col2: naUTL(nationalID.safeHarbourScore),
      col3: naUTL(socialSecurity.safeHarbourScore),
      col4: naUTL(watchlistAML.safeHarbourScore),
    },
    {
      col1: 'Identity Verified',
      col2: naUTL(nationalID.identityVerified),
      col3: naUTL(socialSecurity.identityVerified),
      col4: naUTL(watchlistAML.identityVerified),
    },
    {
      col1: 'ID Card Number Verified',
      col2: naUTL(nationalID.verifications.documentNo),
      col3: naUTL(socialSecurity.verifications.documentNo),
      col4: naUTL(watchlistAML.verifications.documentNo),
    },
    {
      col1: 'Name Verified',
      col2: naUTL(nationalID.verifications.fullName),
      col3: naUTL(socialSecurity.verifications.fullName),
      col4: naUTL(watchlistAML.verifications.fullName),
    },
    {
      col1: 'Name Match Score',
      col2: naUTL(nationalID.nameMatchScore),
      col3: naUTL(socialSecurity.nameMatchScore),
      col4: naUTL(watchlistAML.nameMatchScore),
    },
    {
      col1: 'Date Of Birth Verified',
      col2: naUTL(nationalID.verifications.dateOfBirth),
      col3: naUTL(socialSecurity.verifications.dateOfBirth),
      col4: naUTL(watchlistAML.verifications.dateOfBirth),
    },
    {
      col1: 'Gender Verified',
      col2: naUTL(nationalID.verifications.gender),
      col3: naUTL(socialSecurity.verifications.gender),
      col4: naUTL(watchlistAML.verifications.gender),
    },
    {
      col1: 'Address Verified',
      col2: naUTL(nationalID.address),
      col3: naUTL(socialSecurity.address),
      col4: naUTL(watchlistAML.address),
    },
    {
      col1: 'Address Match Score',
      col2: naUTL(nationalID.addressMatchScore),
      col3: naUTL(socialSecurity.addressMatchScore),
      col4: naUTL(watchlistAML.addressMatchScore),
    },
    {
      col1: 'Error Message',
      col2: naUTL(nationalID.errorMessage),
      col3: naUTL(socialSecurity.errorMessage),
      col4: naUTL(watchlistAML.errorMessage),
    },
  ];

  return tableFilter(table);
};

export default jsonTableRow;
